<script lang="ts">
    
    import { i18n } from "../../Services/i18n"

</script>

<div class="idle-room">
    {$i18n('Ningún juego en la sala')}
</div>

<style lang="scss">

    .idle-room {
        text-align: center;
        font-family: Title;
        font-size: 3rem;
    }

</style>
